import { ComponentFactoryResolver, ComponentRef, Type, ViewContainerRef } from "@angular/core";

export const insertComponentDynamic = <T>(component: Type<T>, resolver: ComponentFactoryResolver, container: ViewContainerRef, args = {}): ComponentRef<T> => {

    const cmpFactory = resolver.resolveComponentFactory(component);
    const compRef = container.createComponent(cmpFactory);

    Object.keys(args).forEach(key => {
        compRef.instance[key] = args[key];
    });

    return compRef;
};



// WEBPACK FOOTER //
// ./src/core/util/insert-component-dynamic.ts